import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  getAllVendors,
  WithgetAllVendors
} from '../../../store/actions/user/User';
import { Redirect } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import LiquorVendorCard from './LiquorVendorCard';
import BackDrop from '../Preloader/BackDrop';
import Loader from '../../Vendor/Loader/Loader';
class Vendor1 extends Component {
  state = {
    isLoading: true
  };
  getCategory() {
    var categoryId = this.props.match.params.superCategory;

    if (categoryId === '63cbec10-3a52-11eb-b806-7567d76cf784') {
      return 'Grocery';
    } else if (categoryId === '') {
      return 'Medicine';
    } else if (categoryId === 'aabca0b0-3a52-11eb-9908-e585f302cee4') {
      return 'Liquor';
    } else if (categoryId === 'ba392a90-3a52-11eb-9908-e585f302cee4') {
      return 'Meat';
    } else if (categoryId === '99c22960-3a52-11eb-9908-e585f302cee4') {
      return 'Vegetables';
    } else if (categoryId === '') {
      return 'Pets';
    } else if (categoryId === 'cf8e7080-3a52-11eb-9908-e585f302cee4') {
      return 'Laundry';
    }
  }
  getCategoryLength() {
    const category = this.getCategory();

    if (category === 'Grocery') {
      return this.props.vendors && this.props.vendors.grocery_vendors.length;
    } else if (category === 'Medicine') {
      return this.props.vendors && this.props.vendors.medicine_vendors.length;
    } else if (category === 'Liquor') {
      return this.props.vendors && this.props.vendors.liquor_vendors.length;
    } else if (category === 'Meat') {
      return this.props.vendors && this.props.vendors.meat_vendors.length;
    } else if (category === 'Vegetables') {
      return this.props.vendors && this.props.vendors.vegetables_vendors.length;
    } else if (category === 'Pets') {
      return this.props.vendors && this.props.vendors.pets_vendors.length;
    } else if (category === 'Laundry') {
      return this.props.vendors && this.props.vendors.laundry_vendors.length;
    }
  }
  componentDidMount() {
    var latitude = localStorage.getItem('latitude');
    var longitude = localStorage.getItem('longitude');
    var categoryId = this.props.match.params.superCategory;
    const category = this.getCategory();
    this.props.withAllVendors(categoryId, category, latitude, longitude);
    setTimeout(() => this.setState({ isLoading: false }), 2000);
  }
  render() {
    if (this.state.isLoading) return <Loader />;

    if (!localStorage.getItem('latitude')) {
      alert('kindly enter your city name in header');
      return <Redirect to="/" />;
    }
    if (this.getCategoryLength() === 0) {
      alert('we will be soon in your region.');
      return <Redirect to="/" />;
    }
    const category = this.getCategory();

    const {
      grocery_vendors,
      medicine_vendors,
      liquor_vendors,
      restaurant_vendors,
      food_vendors,
      cider_vendors,
      champagne_vendors,
      mixeddrinks_vendors,
      redwine_vendors,
      spirits_vendors,
      whitewine_vendors,
      pets_vendors,
      vegetables_vendors,
      laundry_vendors,
      meat_vendors
    } = this.props.vendors;

    return (
      <div
        className="container-fluid"
        style={{ paddingRight: '0', paddingLeft: '0', marginTop: '3.4em' }}
      >
        <div className="banner">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-1 col-md-3 col-sm-4 col-5"
                style={{
                  textAlign: 'left',
                  marginLeft: '2.5%',
                  padding: '0px'
                }}
              >
                {category === 'Grocery' ? (
                  <div>
                    <img src="/img/s1.png" width="100%" alt="grocery" />
                  </div>
                ) : category === 'Medicine' ? (
                  <div>
                    <img src="/img/s3.png" width="100%" alt="medicine" />
                  </div>
                ) : category === 'Liquor' ? (
                  <div>
                    <img src="/img/s2.png" width="100%" alt="liquor" />
                  </div>
                ) : category === 'Meat' ? (
                  <div>
                    <img src="/img/s4.png" width="100%" alt="meat" />
                  </div>
                ) : category === 'Vegetables' ? (
                  <div>
                    <img src="/img/s7.png" width="100%" alt="fruits" />
                  </div>
                ) : category === 'Pets' ? (
                  <div>
                    <img src="/img/s9.png" width="100%" alt="pet" />
                  </div>
                ) : category === 'Laundry' ? (
                  <div>
                    <img src="/img/s5.png" width="100%" alt="Laundry" />
                  </div>
                ) : null}
              </div>
              <div className=" col-sm-auto col-7" style={{ textAlign: 'left' }}>
                <h4
                  style={{
                    color: 'whitesmoke',
                    fontWeight: 'bold',
                    fontSize: '30px'
                  }}
                >
                  {this.props.location.state.category} for you
                </h4>
                {/* <h4 style={{color:'grey'}}>{localStorage.getItem('address')}</h4> */}
                <h5 style={{ color: 'grey' }}>
                  {category === 'Grocery'
                    ? grocery_vendors.length
                    : category === 'Medicine'
                    ? medicine_vendors.length
                    : category === 'Liquor'
                    ? liquor_vendors.length
                    : category === 'Food'
                    ? food_vendors.length
                    : category === 'Restaurant'
                    ? restaurant_vendors.length
                    : category === 'Vegetables'
                    ? vegetables_vendors.length
                    : category === 'Pets'
                    ? pets_vendors.length
                    : category === 'Meat'
                    ? meat_vendors.length
                    : category === 'Laundry'
                    ? laundry_vendors.length
                    : ''}{' '}
                  Store
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          {category === 'Liquor' ? (
            <>
              <h2
                style={{
                  textAlign: 'start',
                  color: '#112c50',
                  fontWeight: 'bold'
                }}
              >
                Recommended Stores For You
              </h2>
              <div
                className="col-12"
                style={{
                  textAlign: 'start',
                  marginLeft: '-1%',
                  color: '#112c50'
                }}
              >
                <i
                  className="fa fa-window-minimize"
                  id="line"
                  aria-hidden="true"
                ></i>
                <i className="fa fa-window-minimize" aria-hidden="true"></i>
              </div>
              <br></br>
            </>
          ) : (
            ''
          )}
          <div className="row">
            {!this.props.loader ? (
              !this.props.vendor_unable ? (
                category === 'Grocery' ? (
                  grocery_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4">
                      <Link
                        to={
                          '/GMshop/' +
                          category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Medicine' ? (
                  medicine_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/GMshop/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Food' ? (
                  food_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Restaurant' ? (
                  restaurant_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Liquor' ? (
                  liquor_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={'/liquor/' + vendor.uid + '/' + vendor.distance}
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Cider' ? (
                  cider_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop2/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all'
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Champegine' ? (
                  champagne_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop2/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all'
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'MixedDrinks' ? (
                  mixeddrinks_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop2/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all'
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'RedWine' ? (
                  redwine_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop2/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all'
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'WhiteWine' ? (
                  whitewine_vendors.map((vendor) => (
                    <div
                      className="col-xs-12 col-lg-6 col-sm-6"
                      key={vendor.uid}
                    >
                      <Link
                        to={
                          '/shop2/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all'
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Vegetables' ? (
                  vegetables_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/GMshop/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Pets' ? (
                  pets_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/GMshop/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Laundry' ? (
                  laundry_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Meat' ? (
                  meat_vendors.map((vendor) => (
                    <div className="col-xs-12 col-sm-4" key={vendor.uid}>
                      <Link
                        to={
                          '/shop/' +
                          category +
                          '/' +
                          vendor.id +
                          '/all' +
                          '/' +
                          vendor.distance
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : category === 'Spirits' ? (
                  spirits_vendors.map((vendor) => (
                    <div
                      className="col-xs-12 col-lg-6 col-sm-6"
                      key={vendor.uid}
                    >
                      <Link
                        to={
                          '/shop2/' +
                          this.props.match.params.category +
                          '/' +
                          vendor.uid +
                          '/all'
                        }
                        className="cardLink"
                      >
                        <LiquorVendorCard
                          key={vendor.uid}
                          vendor={vendor}
                          sub={this.props.match.params.category}
                        ></LiquorVendorCard>
                      </Link>
                    </div>
                  ))
                ) : (
                  ''
                )
              ) : (
                <Typography style={{ marginLeft: '32%' }} variant="h5">
                  Currently not available in your area
                </Typography>
              )
            ) : (
              <BackDrop open={this.props.loader}></BackDrop>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateWithProps = (state) => ({
  vendors: state.user,
  vendor_unable: state.user.vendor_unable,
  loader: state.ui.vendor_loader
});

const mapDispatchToProps = (dispatch) => ({
  getAllVendors: (city, latitude, longitude, category) =>
    dispatch(getAllVendors(city, latitude, longitude, category)),
  // getVendors:()=>dispatch(getVendors())
  withAllVendors: (superCategoryId, superCategory, latitude, longitude) =>
    dispatch(
      WithgetAllVendors(superCategoryId, superCategory, latitude, longitude)
    )
});

export default connect(mapStateWithProps, mapDispatchToProps)(Vendor1);
